<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
};
</script>

<template>
  <content-loader
    width="1276"
    height="153"
    viewBox="0 20 1276 140"
    :speed="2"
    primaryColor="#F9FAFF"
    secondaryColor="#D8DFF6"
    :primaryOpacity="0.9"
    :secondaryOpacity="0.25"
  >
    <rect x="48" y="21" width="151" height="83" rx="4" />
    <rect x="366" y="22" width="151" height="83" rx="4" />
    <rect x="684" y="23" width="151" height="83" rx="4" />
    <rect x="1002" y="24" width="151" height="83" rx="4" />
    <rect x="47" y="114" width="152" height="20" rx="4" />
    <rect x="365" y="115" width="152" height="20" rx="4" />
    <rect x="683" y="116" width="152" height="20" rx="4" />
    <rect x="1001" y="117" width="152" height="20" rx="4" />
  </content-loader>
</template>
